/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pm_DuplicateInputs */

const cs_pm_duplicate = /** @type {(inputs: Pm_DuplicateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vybráno 2×`)
};

const en_pm_duplicate = /** @type {(inputs: Pm_DuplicateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Picked twice`)
};

/**
* | output |
* | --- |
* | "Picked twice" |
*
* @param {Pm_DuplicateInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const pm_duplicate = /** @type {((inputs?: Pm_DuplicateInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pm_DuplicateInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pm_duplicate(inputs)
	return cs_pm_duplicate(inputs)
});